<script setup>
import { ref } from "vue";
import { Link } from "@inertiajs/vue2";
import ManageEnrollment from "./../ManageEnrollment.vue";
import LessonDetailContact from "./LessonDetailContact.vue";

// Props

const props = defineProps({
    lesson: {
        type: Object,
        required: true,
    },
});

// Emits

const emit = defineEmits(["reset", "success"]);

// Reactive State

const showManageEnrollment = ref(false);
const showContact = ref(false);
const selected = ref({});

// Methods

function reset() {
    setTimeout(() => {
        showManageEnrollment.value = false;
    }, 300);
    emit("reset");
}

function handleSuccess() {
    setTimeout(() => {
        showManageEnrollment.value = false;
    }, 300);
    emit("success");
}
</script>

<template>
    <div class="lesson-detail-user">
        <v-list-item class="gap-4">
            <v-list-item-avatar class="cursor-pointer">
                <v-icon>groups</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-subtitle>Students</v-list-item-subtitle>
                <div
                    :class="{ 'flex-wrap': lesson.students.length }"
                    class="flex pb-1"
                >
                    <div
                        v-for="student in lesson.students"
                        :key="student.id"
                        style="width: 30px"
                    >
                        <v-tooltip bottom class="soli-round"
                            ><template v-slot:activator="{ on, attrs }"
                                ><!--<Link
                                    :href="`/profile/${student.id}/account`"
                                    :class="[
                                        student.attendance.status ==
                                            'Late-cancel' ||
                                        student.attendance.status == 'No-show'
                                            ? 'disabled-inertia-link'
                                            : null,
                                    ]"
                                >-->
                                <v-avatar
                                    class="stacked-avatar shadow-md cursor-pointer"
                                    size="36"
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="
                                        selected = student;
                                        showContact = true;
                                    "
                                >
                                    <v-img :src="student.profile_photo_url">
                                    </v-img>
                                </v-avatar>
                                <!--</Link>-->
                            </template>
                            <span>{{ student.name }}</span>
                        </v-tooltip>
                    </div>
                    <SoliBtn
                        class="pa-0.5 shadow-orange-xl"
                        :icon="lesson.students.length == 0 ? 'add' : 'edit'"
                        round
                        gradient="gradient-orange"
                        @click="showManageEnrollment = true"
                        v-if="
                            !lesson.cancelled &&
                            (!lesson.students.length ||
                                !Object.values(lesson.students).every(
                                    (e) =>
                                        e.attendance.status == 'Teacher-cancel'
                                ))
                        "
                    ></SoliBtn>
                    <v-icon
                        v-if="!lesson.students.length && lesson.cancelled"
                        class="pl-2 pa-0.5"
                        >block</v-icon
                    >
                    <!--<v-list-item-title
                        v-if="!lesson.students.length"
                        class="soli-grey flex ml-10"
                        >{{
                            `${
                                lesson.cancelled
                                    ? "Canceled"
                                    : "Enroll Students"
                            }`
                        }}</v-list-item-title
                    >-->
                </div>
            </v-list-item-content>
        </v-list-item>
        <LessonDetailContact
            v-if="showContact"
            :title="selected.name"
            :contact="
                selected.relationships.filter((e) => !!e.email)[0] ?? selected
            "
            @reset="
                showContact = false;
                selected = {};
            "
        />
        <ManageEnrollment
            v-if="showManageEnrollment"
            :event="lesson"
            @reset="reset()"
            @success="handleSuccess()"
        />
    </div>
</template>
